export class UserNotConnectedError extends Error {}
